import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import PropTypes from "prop-types";

const styles = StyleSheet.create({
  page: {
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 16,
    paddingRight: 16,
  },
  section: {
    margin: 4,
  },
  title: {
    textDecoration: "underline",
    textAlign: "center",
    fontSize: 14,
    marginBottom: 12,
  },
  headerContainer: {
    flexDirection: "row",
  },
  header: {
    fontWeight: "bold",
    fontSize: 6,
    flex: 1,
    padding: 3,
    textAlign: "center",
    border: "1px solid #ddd",
    backgroundColor: "#000000",
    color: "#FFFFFF",
  },
  row: {
    flexDirection: "row",
  },
  cell: {
    border: "1px solid #ddd",
    flex: 1,
    padding: 3,
    fontSize: 6,
    textAlign: "center",
  },
});

const RtmClaimDetailsPdfDoc = ({ data, columns, title }) => (
  <Document>
    <Page style={styles.page} size="A4" orientation="landscape">
      <View style={styles.section}>
        <Text style={styles.title}>{title}</Text>
        <View style={styles.headerContainer}>
          {columns.map((col) => (
            <Text key={col.key} style={styles.header}>{col.header}</Text>
          ))}
        </View>
        {(Array.isArray(data) ? data : []).map((item, index) => (
          <View key={index} style={styles.row}>
            {columns.map((col) => (
              <Text key={col.key} style={styles.cell}>{item[col.key] ?? "--"}</Text>
            ))}
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

RtmClaimDetailsPdfDoc.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
};

RtmClaimDetailsPdfDoc.defaultProps = {
  data: [],
};

export default RtmClaimDetailsPdfDoc;
